import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import { List } from '@prisjakt/ui-filters';
import T from '@prisjakt/ui-translate';
import { bemGenerator } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

const styles = bemGenerator('campaign-stores', ['no-items']);

const Stores = props => {
  const { stores, hasMore } = props;
  const { t } = useContext(AppContext);

  if (!stores) {
    return null;
  }

  return (
    <span>
      {stores.length > 0 && (
        <span>
          <List
            id="store"
            values={stores}
            selected={props.selected}
            onChange={selected => {
              props.onChange(selected);
            }}
          />
          {hasMore && (
            <Button
              variant="text"
              color="link"
              onClick={() => {
                props.onMoreChanged(!props.showingMore);
              }}
            >
              {t(
                'filter',
                props.showingMore
                  ? 'properties.quantity-show-less'
                  : 'properties.quantity-show-more'
              )}
            </Button>
          )}
        </span>
      )}
      {stores.length === 0 && (
        <p className={styles['no-items']}>
          <T domain="campaigns">store.no-items</T>
        </p>
      )}
    </span>
  );
};

const { arrayOf, func, number, object, shape, string, bool } = PropTypes;

Stores.propTypes = {
  campaignId: number.isRequired,
  data: object, // eslint-disable-line react/forbid-prop-types,
  onChange: func.isRequired,
  selected: arrayOf(string).isRequired,
  hasMore: bool.isRequired,
  showingMore: bool.isRequired,
  onMoreChanged: func.isRequired,
  stores: arrayOf(
    shape({
      id: string.isRequired,
      name: string.isRequired,
      products: number.isRequired,
    })
  ),
};

Stores.defaultProps = { data: null, stores: [] };

/* eslint-disable no-underscore-dangle */
export const mapStores = aggregations =>
  (aggregations &&
    aggregations.stores &&
    aggregations.stores.current &&
    aggregations.stores.current.buckets &&
    aggregations.stores.current.buckets.map(store => ({
      id: `${store.top_hits.hits.hits[0]._source.store.id}`,
      name: store.top_hits.hits.hits[0]._source.store.name,
      products: store.top_hits.hits.total,
    }))) ||
  [];

export default memo(Stores);
